import Button from "../../components/Button/Button";
import React, { useEffect, useState } from "react";
import { SideBar } from "../../components/SideBar/SideBar";
import "./ListingProfile.css";
import SliderComponent from "../../components/Slider/Slider";
import useAuthService from "../../auth/AuthService";
import { GetListingProfile } from "../../services/listing.service";
import { handleDate } from "../../utils/formatdate";
// import { Link } from "react-router-dom";
import CharityModel from "../../components/Modal/CharityModel/CharityModel";
import { Link, useNavigate } from "react-router-dom";
import { SaveCharityPreferences } from "../../services/charity.service";
import { handleMessage } from "../../utils/handleMessagePopup";
import { CreateStripeConnectAccount, GetStripeConnectAccountDetails, GetStripeDashboardLink, UpdatePopupShow } from "../../services/stripeConnect.service";
import NullPageComponent from "../../components/Tile/NullPageComponent";

interface ListingProfileProps {
  userRole: string;
}

const ListingProfile: React.FC<ListingProfileProps> = ({ userRole }) => {
  const { isAuthenticated, getToken } = useAuthService();
  const navigate = useNavigate();
  const [state, setState] = useState({
    isLoading: false,
    isFileUploader: false,
    isCharityOpen: false,
    price: 0,
    id: "",
    fan_id: "",
    fanName: "",
    public_id: "",
    fullname: "",
    birthname: "",
    bio: "",
    date_of_birth: "",
    image_url: "",
    last_price_paid: "",
    value: "",
    buy_now_price: "",
    membership_begin: "",
    membership_end: "",
    next_auction: "",
    followers: "",
    rank: "",
    charitable_contribution: 0,
    charity_name: "",
    charitable_value: "",
    fetchData: true,
    stripeConnectData: {
      stripe_connect_id: "",
      is_charges_enabled: false,
      is_payouts_enabled: false,
      is_popup_show: false
    },
    showNullPage: true,
  });

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const fetchAllData = async () => {
      try {
        handleToggle("isLoading", true);
        // Step 1: Get Listing Profile
        const response = await GetListingProfile(getToken);
        if (response?.data && response?.error === null) {
          setState((prev) => ({
            ...prev,
            id: response.data.id,
            image_url: response.data.image_url,
            fan_id: response.data.fan_id,
            fanName: response.data.fanName,
            public_id: response.data.public_id,
            fullname: response.data.fullName,
            birthname: response.data.birthname,
            bio: response.data.bio || "",
            date_of_birth:
              response.data.date_of_birth == null
                ? ""
                : response.data.date_of_birth.split("T")[0] || "",
            last_price_paid: response.data.last_price_paid,
            value: response.data.value,
            buy_now_price: response.data.buy_now_price,
            membership_begin: response.data.membership_begin,
            membership_end: response.data.membership_end,
            next_auction: response.data.next_auction,
            followers: response.data.followers,
            rank: response.data.rank,
            charity_name: response.data.charity_name,
            charitable_value: response.data.charitable_contribution,
          }));
        }

        // Step 2: Delay and fetch Stripe Connect data if needed
        timeoutId = setTimeout(async () => {
          if (
            isAuthenticated &&
            state.stripeConnectData.stripe_connect_id === ""
          ) {
            const res: any = await GetStripeConnectAccountDetails(getToken);
            if (res.data && res.error === null) {
              setState((prev) => ({
                ...prev,
                stripeConnectData: res.data,
              }));
            }
          }

          handleToggle("isLoading", false);
        }, 1000);
      } catch (error) {
        console.error("An error occurred while fetching data", error);
        setState((pre) => ({ ...pre, isLoading: false }));
      }
    };

    fetchAllData();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
    //eslint-disable-next-line
  }, [getToken, state.fetchData]);

  const handleSliderChange = (type: string, value: number) => {
    setState((pre) => ({ ...pre, charitable_contribution: value }));
  };

  const handleToggle = (key: keyof typeof state, value: boolean) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const handleSaveCharity = async (charityId: string) => {
    try {
      if (isAuthenticated) {
        const data = {
          charity_id: charityId,
          entity_id: state.id,
          charitable_contribution: state.charitable_contribution,
        };
        handleToggle("isLoading", true);
        const res = await SaveCharityPreferences(data, getToken);
        if (res.data === "success" && res.error === null) {
          handleMessage("Charity Preference added successfully");
          handleToggle("isCharityOpen", false);
          setState((prev) => ({ ...prev, fetchData: !prev.fetchData }));
        }
      }
    } catch {
      console.error("Error in saving charity preferences.");
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const handleCreateStripeConnectAccount = async () => {
    handleToggle("isLoading", true);
    try {
      const res = await CreateStripeConnectAccount(getToken);

      if (res?.data !== null && res.error === null) {
        window.location.href = res.data.onboarding_link;
      } else {
        console.error("No URL found in response");
      }
    } catch (error) {
      console.error("Error creating Stripe connect account:", error);
      handleToggle("isLoading", false);
    }
  };

  const handleGetStripeDashboardLink = async () => {
    handleToggle("isLoading", true);
    try {
      const res = await GetStripeDashboardLink(getToken);

      if (res?.data !== null && res.error === null) {
        window.open(res.data.data, "_blank");
      } else {
        console.error("No URL found in response");
      }
    } catch (error) {
      console.error("Error creating Stripe connect account:", error);
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const isStripeVerified =
    state.stripeConnectData.stripe_connect_id !== "" &&
    state.stripeConnectData.is_charges_enabled &&
    state.stripeConnectData.is_payouts_enabled &&
    !state.stripeConnectData.is_popup_show;

  useEffect(() => {
    const fetchData = async () => {
      if (isStripeVerified && state.showNullPage) {
        await UpdatePopupShow(getToken)
      }
    }

    fetchData();
    //eslint-disable-next-line
  }, [isStripeVerified, state.showNullPage])

  useEffect(() => {
    const timer = setTimeout(() => {
      setState((prev) => ({ ...prev, showNullPage: false }));
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="container profile-page ps-2">
        <div className="edit-profile-header py-4">Settings</div>
        <div className="profile-page-data">
          <div className="payout-null position-absolute">
            {isStripeVerified && state.showNullPage && (
              <NullPageComponent
                heading1="Thank you!"
                heading2="Your payout information has been submitted."
                heading3="Stripe is verifying your details. If additional information is needed, we will notify you."
                button1={
                  <Button
                    label="Check your payout status"
                    icon={<i className="fa-regular fa-user ms-2"></i>}
                    className="btn"
                    onClick={() => navigate("/settings/listing")}
                    variant="dark"
                  />
                }
              />
            )}
            {state.showNullPage && state.stripeConnectData.stripe_connect_id !== "" &&
              !state.stripeConnectData.is_charges_enabled &&
              !state.stripeConnectData.is_payouts_enabled && (
                <NullPageComponent
                  heading1="Almost There!"
                  heading2="Your payout account needs additional verification."
                  heading3="Please return to Stripe to complete your setup."
                  button1={
                    <Button
                      label="Check your payout status"
                      icon={<i className="fa-regular fa-user ms-2"></i>}
                      className="btn"
                      onClick={() => navigate("/settings/listing")}
                      variant="dark"
                    />
                  }
                />
              )}
          </div>
          <div className="side-bar">
            <SideBar ActiveItem="listingProfile" userRole={userRole} />
          </div>
          <div className="page-content pb-0">
            <div className="profile-content">
              <div className="heading mb-3">Listing</div>
              <div className="profile-data">
                <figure className="user-profile-img d-flex flex-md-column">
                  {state.isLoading ? (
                    <div className="loader">
                      <div className="spinner"></div>
                    </div>
                  ) : (
                    <>
                      {!state.image_url ? (
                        <div
                          style={{ borderRadius: "4px 4px 0px 0px" }}
                          className="user-profile-img text-dark-purple bg-extra-light-purple position-relative"
                        >
                          <i className="fa-solid fa-user pt-4 d-flex justify-content-center"></i>
                          {/* <Button
                            className="position-absolute user-profile-btn"
                            label={"Add Photo"}
                            onClick={() =>
                              handleToggle(
                                "isFileUploader",
                                !state.isFileUploader
                              )
                            }
                          /> */}
                        </div>
                      ) : (
                        <div className="w-100 h-100">
                          <img
                            src={state.image_url}
                            alt={state?.fullname || "N/A"}
                            className="user-profile-img"
                            loading="lazy"
                          />
                        </div>
                      )}
                    </>
                  )}
                  <div className="my-md-2 text-center user-profile-data ms-2 ms-md-0 d-flex flex-column justify-content-between my-0">
                    <div className="font-300-15">
                      Fan1 Verified{" "}
                      <span>
                        {" "}
                        <svg
                          width="15"
                          height="16"
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 0.875C8.55469 0.875 9.49219 1.49023 9.96094 2.39844C10.9277 2.07617 12.041 2.31055 12.8027 3.07227C13.5645 3.83398 13.7988 4.94727 13.4766 5.91406C14.3848 6.38281 15 7.32031 15 8.375C15 9.45898 14.3848 10.3965 13.4766 10.8652C13.7988 11.832 13.5645 12.916 12.8027 13.6777C12.041 14.4395 10.9277 14.6738 9.96094 14.3809C9.49219 15.2891 8.55469 15.875 7.5 15.875C6.41602 15.875 5.47852 15.2891 5.00977 14.3809C4.04297 14.6738 2.95898 14.4395 2.19727 13.6777C1.43555 12.916 1.20117 11.832 1.49414 10.8652C0.585938 10.3965 0 9.45898 0 8.375C0 7.32031 0.585938 6.38281 1.49414 5.91406C1.20117 4.94727 1.43555 3.83398 2.19727 3.07227C2.95898 2.31055 4.04297 2.07617 5.00977 2.39844C5.47852 1.49023 6.41602 0.875 7.5 0.875ZM10.8105 6.99805C11.0742 6.73438 11.0742 6.29492 10.8105 6.03125C10.5176 5.73828 10.0781 5.73828 9.81445 6.03125L6.5625 9.2832L5.18555 7.90625C4.89258 7.61328 4.45312 7.61328 4.18945 7.90625C3.89648 8.16992 3.89648 8.60938 4.18945 8.87305L6.06445 10.748C6.32812 11.041 6.76758 11.041 7.06055 10.748L10.8105 6.99805Z"
                            fill="#8671FC"
                          />
                        </svg>
                      </span>
                    </div>
                    {/* <div className="font-300-15 mt-2">
                      Followers {state?.followers || "N/A"}
                    </div>
                    <div className="font-300-15 mt-2">
                      Rank {state?.rank || "N/A"}
                    </div> */}
                    <Button
                      type="button"
                      label={<>View Listing</>}
                      className="py-2 mt-3 button"
                      onClick={() =>
                        navigate(`/${state.public_id}`, {
                          state: { id: state.id },
                        })
                      }
                    />
                  </div>
                </figure>
                <div className="listing-details">
                  <div className="personal-details row pb-0 pb-md-4">
                    <div className="profileDetails col-12 col-md-6 border-bottom-light-custom pb-4 px-0 mx-2 mx-md-0">
                      <div className="sub-heading d-flex mb-2">
                        Profile Details
                      </div>
                      <div className="d-flex align-items-baseline mb-2">
                        <div className="heading">Current Fan1</div>
                        <div className="content">
                          <span
                            onClick={() => navigate(`/u/${state?.fanName}`)}
                            className="text-decoration-none purple-color"
                          >
                            {state?.fanName ? `@${state?.fanName}` : "N/A"}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-baseline mb-2">
                        <div className="heading">Followers</div>
                        <div className="content">
                          {state?.followers || "N/A"}
                        </div>
                      </div>
                      <div className="d-flex align-items-baseline mb-2">
                        <div className="heading">Rank</div>
                        <div className="content">{state?.rank || "N/A"}</div>
                      </div>
                      <div className="d-flex align-items-baseline mb-2">
                        <div className="heading">ID</div>
                        <div className="content pe-4">
                          {/* <div className="fanid"> */}
                          {state?.public_id || "N/A"}
                          {/* <svg
                              width="17"
                              height="13"
                              viewBox="0 0 17 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                verticalAlign: "0px",
                                marginLeft: "2px",
                              }}
                            >
                              <path
                                d="M15.8359 11.8438C16 11.9609 16.0469 12.1953 15.9062 12.3594C15.7891 12.5234 15.5547 12.5469 15.3906 12.4297L1.14062 1.17969C0.976562 1.0625 0.929688 0.828125 1.07031 0.664062C1.1875 0.5 1.42188 0.453125 1.58594 0.59375L15.8359 11.8438ZM14.1016 3.75781L11.1484 6.71094L10.5625 6.24219L11.7344 5.04688L9.95312 3.24219L8.54688 4.64844L7.96094 4.17969L11.2422 0.898438C11.7578 0.40625 12.5781 0.40625 13.0938 0.898438L14.1016 1.90625C14.5938 2.42188 14.5938 3.24219 14.1016 3.75781ZM12.5547 1.4375C12.3438 1.22656 11.9922 1.22656 11.7578 1.4375L10.4922 2.72656L12.2734 4.50781L13.5625 3.24219C13.7734 3.00781 13.7734 2.65625 13.5625 2.44531L12.5547 1.4375ZM8.42969 8.375L9.01562 8.84375L6.76562 11.0938C6.48438 11.3516 6.15625 11.5625 5.80469 11.6562L2.96875 12.5C2.82812 12.5234 2.6875 12.5 2.59375 12.4062C2.5 12.3125 2.45312 12.1719 2.5 12.0312L3.34375 9.19531C3.4375 8.84375 3.64844 8.51562 3.90625 8.23438L5.82812 6.3125L6.41406 6.78125L4.75 8.44531L5.05469 9.94531L6.55469 10.25L8.42969 8.375ZM4.14062 9.19531C4.11719 9.26562 4.07031 9.33594 4.04688 9.40625L3.41406 11.5859L5.59375 10.9531C5.66406 10.9297 5.73438 10.8828 5.80469 10.8594L4.65625 10.625C4.51562 10.6016 4.39844 10.4844 4.375 10.3438L4.14062 9.19531Z"
                                fill="#CBC0EA"
                              />
                            </svg>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="profileDetails col-12 col-md-6 border-bottom-light-custom pb-4 px-0 mx-2 mx-md-0">
                      {isAuthenticated && userRole === "moderator" && (<>
                        <h4 className="sub-heading d-flex mt-4 mt-md-0 mb-3">
                          Payout Information
                        </h4>
                        <div className="d-flex align-items-center">
                          <div className="p-0">
                            {state.stripeConnectData.stripe_connect_id === "" && (
                              <div
                                className="btn btn-primary button mt-3"
                                onClick={handleCreateStripeConnectAccount}
                              >
                                Set up payouts to your bank
                                <svg
                                  className="ms-2"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.32227 0.962891L14.9727 4.6543C15.2949 4.83008 15.5 5.15234 15.5 5.50391C15.5 6.06055 15.0312 6.5 14.5039 6.5H1.49609C0.939453 6.5 0.5 6.06055 0.5 5.50391C0.5 5.15234 0.675781 4.83008 0.998047 4.6543L7.64844 0.962891C7.85352 0.845703 8.11719 0.845703 8.32227 0.962891ZM7.17969 5.09375C7.0918 4.97656 7.0625 4.80078 7.0625 4.625C7.0625 4.12695 7.47266 3.6875 8 3.6875C8.49805 3.6875 8.9375 4.12695 8.9375 4.625C8.9375 4.80078 8.87891 4.97656 8.79102 5.09375H12.8926L8 2.39844L3.07812 5.09375H7.17969ZM2.375 7.4375H3.78125V12.125H5.65625V7.4375H7.0625V12.125H8.9375V7.4375H10.3438V12.125H12.2188V7.4375H13.625V12.125H13.8594C14.2402 12.125 14.5625 12.4473 14.5625 12.8281C14.5625 13.2383 14.2402 13.5312 13.8594 13.5312H2.375C1.96484 13.5312 1.67188 13.2383 1.67188 12.8281C1.67188 12.4473 1.96484 12.125 2.375 12.125V7.4375ZM1.4375 14.4688H14.7969C15.1777 14.4688 15.5 14.791 15.5 15.1719C15.5 15.582 15.1777 15.875 14.7969 15.875H1.4375C1.02734 15.875 0.734375 15.582 0.734375 15.1719C0.734375 14.791 1.02734 14.4688 1.4375 14.4688Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                            )}

                            {state.stripeConnectData.stripe_connect_id !== "" &&
                              !state.stripeConnectData.is_charges_enabled &&
                              !state.stripeConnectData.is_payouts_enabled && (
                                <>
                                  <p className="d-flex align-items-center">
                                    <svg
                                      width="19"
                                      height="19"
                                      viewBox="0 0 19 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.17188 6.84375C2.9375 7.3125 2.39062 7.50781 1.92188 7.3125C1.45312 7.11719 1.21875 6.57031 1.41406 6.10156C2.74219 2.97656 5.86719 0.75 9.5 0.75C11.5312 0.75 13.4844 1.57031 14.9297 3.01562L17 5.08594V2.9375C17 2.42969 17.3906 2 17.9375 2C18.4453 2 18.875 2.42969 18.875 2.9375V7.3125C18.875 7.85938 18.4453 8.25 17.9375 8.25H13.5625C13.0156 8.25 12.625 7.85938 12.625 7.3125C12.625 6.80469 13.0156 6.375 13.5625 6.375H15.6719L13.6016 4.34375C12.5078 3.25 11.0234 2.625 9.5 2.625C6.64844 2.625 4.1875 4.38281 3.17188 6.84375ZM17.5469 12.9766C16.1797 16.0625 13.0938 18.25 9.5 18.25C7.42969 18.25 5.47656 17.4688 4.03125 15.9844L2 13.9531V16.0625C2 16.6094 1.57031 17 1.0625 17C0.515625 17 0.125 16.6094 0.125 16.0625V11.6875C0.125 11.1797 0.515625 10.75 1.0625 10.75H5.4375C5.94531 10.75 6.375 11.1797 6.375 11.6875C6.375 12.2344 5.94531 12.625 5.4375 12.625H3.28906L5.35938 14.6953C6.45312 15.7891 7.9375 16.375 9.5 16.375C12.3125 16.375 14.7734 14.6953 15.7891 12.2344C16.0234 11.7266 16.5703 11.5312 17.0391 11.7266C17.5078 11.9219 17.7422 12.4688 17.5469 12.9766Z"
                                        fill="#FFBE33"
                                      />
                                    </svg>
                                    <span className="ms-2 font-500-20">
                                      Payout setup in progress.
                                    </span>
                                  </p>
                                  <p className="font-inter-300-15">
                                    Please check your email or
                                    <span
                                      className="text-light-purple cursor-pointer"
                                      onClick={handleCreateStripeConnectAccount}
                                    >
                                      {" "}
                                      click here{" "}
                                    </span>
                                    to continue.
                                  </p>
                                </>
                              )}
                            {state.stripeConnectData.stripe_connect_id !== "" &&
                              state.stripeConnectData.is_charges_enabled &&
                              state.stripeConnectData.is_payouts_enabled && (
                                <>
                                  <p className="font-500-20">Account Status</p>
                                  <p className="font-inter-300-15 d-flex align-items-center">
                                    <i className="fa-solid fa-square-check text-light-purple me-2"></i>
                                    <span className="font-inter-300-15">
                                      Your account is ready to receive payouts.
                                    </span>
                                  </p>
                                  <p className="font-500-20">Update info or review your payouts</p>
                                  <div
                                    className="btn btn-primary button"
                                    onClick={handleGetStripeDashboardLink}
                                  >
                                    Payout info at
                                    <svg width="39" height="17" viewBox="0 0 39 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-2">
                                      <path d="M26.583 3.92969C28.4301 3.92984 30.172 5.5974 30.1826 8.6582C30.1826 12.0043 28.4617 13.5244 26.5723 13.5244C25.6434 13.5244 25.0841 13.1338 24.7041 12.8594L24.6934 15.8467L22.0547 16.4062V4.09863H24.377L24.5137 4.75293C24.8831 4.41515 25.5486 3.92969 26.583 3.92969ZM4.06738 3.92969C4.94348 3.92969 5.80945 4.06672 6.68555 4.41504V6.89551C5.88334 6.46276 4.86958 6.21973 4.06738 6.21973C3.50821 6.2198 3.17095 6.37853 3.1709 6.79004C3.1709 7.97226 7.19257 7.41304 7.20312 10.5586C7.20305 12.4479 5.69341 13.5351 3.49805 13.5352C2.59031 13.5352 1.59783 13.3558 0.616211 12.9336V10.4209C1.50288 10.9065 2.62194 11.2656 3.49805 11.2656C4.0889 11.2656 4.51058 11.1073 4.51074 10.6221C4.51074 9.36599 0.500182 9.83011 0.5 6.91699C0.5 5.04877 1.92483 3.92983 4.06738 3.92969ZM10.2959 4.10938H12.3008V6.35742H10.2959V10.1045C10.2959 11.6663 11.9624 11.1813 12.3008 11.0439V13.1865C11.9525 13.3765 11.3194 13.5351 10.4541 13.5352C8.89188 13.5352 7.71973 12.3845 7.71973 10.8223L7.73047 2.36719L10.3057 1.81836L10.2959 4.10938ZM34.6895 3.92969C37.191 3.92971 38.4999 6.06163 38.5 8.76367C38.5 9.0168 38.4785 9.56534 38.4785 9.70312H33.3174C33.4335 10.9487 34.3413 11.3076 35.3652 11.3076C36.4101 11.3076 37.2335 11.0864 37.9512 10.7275V12.8389C37.2334 13.2399 36.2833 13.5244 35.0273 13.5244C32.4519 13.5244 30.6573 11.9202 30.6572 8.74316C30.6572 6.06205 32.1772 3.92969 34.6895 3.92969ZM15.584 4.88965C16.2067 3.75021 17.4412 3.98172 17.7793 4.1084V6.53613C17.4518 6.42003 16.3961 6.27336 15.7734 7.08594V13.3447H13.1348V4.1084H15.415L15.584 4.88965ZM21.0732 13.3447H18.4238V4.1084H21.0732V13.3447ZM25.9492 6.27246C25.3477 6.27251 24.9678 6.484 24.6934 6.79004L24.7041 10.7061C24.9574 10.9805 25.3266 11.2021 25.9492 11.2021C26.9203 11.2021 27.5752 10.1468 27.5752 8.73242C27.5752 7.34964 26.9098 6.27246 25.9492 6.27246ZM34.6787 6.07227C34.0137 6.07233 33.2852 6.56902 33.2852 7.76172H36.0088C36.0088 6.56894 35.3226 6.07227 34.6787 6.07227ZM21.0732 2.73633L18.4238 3.30664V1.15332L21.0732 0.59375V2.73633Z" fill="#070115" />
                                    </svg>
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.1875 1.59375C11.1875 1.13672 11.5391 0.75 12.0312 0.75H17.6562C18.1133 0.75 18.5 1.13672 18.5 1.59375V7.21875C18.5 7.71094 18.1133 8.0625 17.6562 8.0625C17.1641 8.0625 16.8125 7.71094 16.8125 7.21875L16.7773 3.63281L8.9375 11.4727C8.62109 11.8242 8.09375 11.8242 7.77734 11.4727C7.42578 11.1562 7.42578 10.6289 7.77734 10.2773L15.6172 2.4375H12.0312C11.5391 2.4375 11.1875 2.08594 11.1875 1.59375ZM3.03125 1.875H7.53125C7.98828 1.875 8.375 2.26172 8.375 2.71875C8.375 3.21094 7.98828 3.5625 7.53125 3.5625H3.03125C2.53906 3.5625 2.1875 3.94922 2.1875 4.40625V16.2188C2.1875 16.7109 2.53906 17.0625 3.03125 17.0625H14.8438C15.3008 17.0625 15.6875 16.7109 15.6875 16.2188V11.7188C15.6875 11.2617 16.0391 10.875 16.5312 10.875C16.9883 10.875 17.375 11.2617 17.375 11.7188V16.2188C17.375 17.625 16.2148 18.75 14.8438 18.75H3.03125C1.625 18.75 0.5 17.625 0.5 16.2188V4.40625C0.5 3.03516 1.625 1.875 3.03125 1.875Z" fill="black" />
                                    </svg>
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      </>)}
                    </div>
                  </div>

                  <div className="financial-info mt-3 row flex-md-row flex-column-reverse">
                    <div className="financial-details col-12 col-md-6 pt-4 pt-md-0">
                      <div className="col-lg-12">
                        <h4 className="sub-heading d-flex mb-3">
                          Membership Info
                        </h4>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Last Price Paid</div>
                          <div className="content my-auto">
                            {state?.last_price_paid
                              ? `$${state?.last_price_paid}`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Value</div>
                          <div className="content my-auto">
                            {state?.value ? `$${state?.value}` : "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Membership Start</div>
                          <div className="content my-auto">
                            {handleDate(state?.membership_begin) || "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Membership End</div>
                          <div className="content my-auto">
                            {handleDate(state?.membership_end) || "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Next Auction</div>
                          <div className="content my-auto">
                            {handleDate(state?.next_auction) || "N/A"}
                          </div>
                        </div>
                        {/* <div className="d-flex align-items-baseline mb-2">
                            <div className="heading">Buy Now Price</div>
                            <div className="content my-auto">
                              {state?.buy_now_price || "N/A"}
                            </div>
                          </div> */}
                      </div>
                    </div>
                    <div className="financial-details col-12 col-md-6 border-bottom-light-custom pb-4 pb-md-0 px-0 mx-2 mx-md-0">
                      <div className="payout-details">
                        <h4 className="sub-heading d-flex mb-3">
                          Charity Preferences
                        </h4>
                        <div className="d-flex flex-md-row flex-column my-2 align-md-items-center">
                          <span className="font-300-15 d-block heading" style={{ width: "100%" }}>
                            Charitable Contribution
                          </span>
                          {state.charitable_value !== "" &&
                            state.charitable_value !== null ? (
                            <div className="content">
                              {state?.charitable_value}%
                            </div>
                          ) : (
                            <SliderComponent
                              label={""}
                              minRange={0}
                              maxRange={100}
                              inputValue={state.price}
                              onChange={handleSliderChange}
                            />
                          )}
                        </div>
                        <div className="d-flex align-items-baseline">
                          <span className="font-300-15 heading">Charity</span>
                          {state.charity_name ? (
                            <div className="content"> {state?.charity_name} </div>
                          ) : (
                            <>
                              <CharityModel
                                isVisible={state.isCharityOpen}
                                onClose={() => {
                                  handleToggle("isCharityOpen", false);
                                }}
                                handleSaveCharity={handleSaveCharity}
                              />
                              <div className="charity-text my-2 ms-2">
                                <Link
                                  to="/"
                                  className="font-400-15 text-decoration-none color-Light-Purple"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleToggle("isCharityOpen", true);
                                  }}
                                >
                                  Select Charity{" "}
                                  <span>
                                    <i className="fa-solid fa-angle-right"></i>
                                  </span>
                                </Link>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Membership Start</div>
                          <div className="content my-auto">
                            {handleDate(state?.membership_begin) || "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Membership End</div>
                          <div className="content my-auto">
                            {handleDate(state?.membership_end) || "N/A"}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Next Auction</div>
                          <div className="content my-auto">
                            {handleDate(state?.next_auction) || "N/A"}
                          </div>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListingProfile;
